import { deserialize } from 'cerialize'
import { StatusType, ManagerType } from 'Pages/partner'
import { getDate } from 'Helpers'

export class PartnerOneDayShortModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public vat_number: string
	@deserialize public status: StatusType
	@deserialize public manager: ManagerType
	@deserialize public created_at: string
	public get created_at_formatted(): string | undefined {
		return getDate(this?.created_at)
	}
}
